import { initSentry } from 'app/config/sentryConfig';
import customParseFormat from 'dayjs/plugin/customParseFormat';
import dayjs from 'dayjs';

function unregisterServiceWorkers() {
  if ('serviceWorker' in navigator && window.isSecureContext) {
    navigator.serviceWorker.getRegistrations().then((registrations) => {
      registrations.forEach((registration) => {
        registration.unregister();
      });
    });
  } else {
    console.warn('Service Workers are not supported');
  }
}

export function initCommon() {
  initSentry(APP_VERSION || 'dev');
  unregisterServiceWorkers();
  console.log(`START APP ${APP_VERSION}`);
  dayjs.extend(customParseFormat);
}
